import { createReducer, on } from '@ngrx/store';
import {
  updateCartItem,
  updateCartItemFail,
  updateCartItemSuccess,
  getCart,
  getCartFail,
  getCartSuccess,
  updateCart,
} from '@b2b/features/cart/core/store/cart.actions';
import {
  failStatus,
  GenericRequest,
  initialStatus,
  loadingStatus,
  successStatus,
} from '@core/models/request-status.model';
import { Cart } from '@b2b/features/cart/utilities/cart.model';
import { CART_ID_KEY } from '@shared/tools/constants';

export type CartState = GenericRequest<Cart>;

const initialState: GenericRequest<Cart> = {
  data: {} as Cart,
  ...initialStatus,
};

export const cartReducer = createReducer(
  initialState,

  on(updateCart, (state: CartState, data): CartState => {
    const response: CartState = {
      ...state,
      data: {
        ...state.data,
        name: data.name,
      } as Cart,
    };

    return response;
  }),

  // UPDATE CART ITEM
  on(updateCartItem, (state: CartState): CartState => {
    const response: CartState = {
      ...state,
      ...loadingStatus,
    };

    return response;
  }),

  on(updateCartItemSuccess, (_state: CartState, cart): CartState => {
    const response: CartState = {
      data: cart.data,
      ...successStatus,
    };

    return response;
  }),

  on(updateCartItemFail, (_state: CartState, data: any): CartState => {
    const response: CartState = {
      ..._state,
      ...failStatus,
      message: data.message,
    };

    return response;
  }),

  // GET CART
  on(getCart, (state: CartState): CartState => {
    const response: CartState = {
      ...state,
      ...loadingStatus,
      message: '',
    };

    return response;
  }),

  on(getCartSuccess, (_state: CartState, cart): CartState => {
    if (cart.data?.code) {
      localStorage.setItem(CART_ID_KEY, cart.data.code);
    }

    const response: CartState = {
      data: cart.data,
      ...successStatus,
    };

    return response;
  }),

  on(getCartFail, (_state: CartState, data: any): CartState => {
    const response: CartState = {
      ...initialState,
      ...failStatus,
      message: data.message,
    };

    return response;
  }),
);
